// utils/urls.js
/**
 * Base URL for your API.
 * Change this to your development or production server URL.
 * Example: 'https://api.your-app.com/v1' or 'http://localhost:3000/api'
 */

const isProduction = true;
export const BASE_URL = isProduction ? 'https://api.tribetwentyfive.com' : 'http://localhost:3000';
const WS_URL = isProduction ? 'wss://api.tribetwentyfive.com' : 'ws://localhost:3000';

/**
 * API Endpoints
 */

export const URLS = {
  LOGIN: BASE_URL + '/api/admin-auth/login',
  REFRESH: BASE_URL + '/api/admin-auth/refresh',
  GET_USERS: BASE_URL + '/api/admin-panel/users',
  GET_SINGLE_USER: (userId) => BASE_URL + `/api/admin-panel/users/${userId}`,
  GET_USER_QUIZ_RESULT: (userId) => BASE_URL + `/api/admin/result/${userId}`,
  GET_SINGLE_USER_FRIENDS: (userId) => BASE_URL + `/api/admin-panel/users/${userId}/friends`,
  BLOCK_USER: (userId) => BASE_URL + `/api/admin-panel/block/${userId}`,
  ME: BASE_URL + '/api/admin-panel/me',
  GET_REPORTS: BASE_URL + '/api/admin-panel/reports',
  DISMISS_REPORT: (id) => BASE_URL + `/api/admin-panel/reports/${id}/dismiss`,
  PARDON_USER: (id) => BASE_URL + `/api/admin-panel/users/${id}/pardon`,
  MODERATION_MESSAGES: (u1, u2) => BASE_URL + `/api/admin-panel/moderation/messages/${u1}/${u2}`,
  BULK_NOTIFICATIONS: BASE_URL + '/api/admin-panel/notifications/bulk',
  AUDIT_LOGS: BASE_URL + '/api/admin-panel/audit-logs',
  GET_ADMINS: BASE_URL + '/api/admin-panel/get-admins',
  DELETE_ADMIN: (userId) => BASE_URL + `/api/admin-panel/delete-admin/${userId}`,
  UPDATE_ADMIN: (userId) => BASE_URL + `/api/admin-panel/update-admin/${userId}`,
  CREATE_ADMIN: BASE_URL + '/api/admin-panel/create-admin',
  STATS: BASE_URL + '/api/admin-panel/stats',
  GET_TRANSACTIONS: BASE_URL + '/api/admin-panel/transactions',
  PROCESSES: BASE_URL + '/api/admin-server/processes',

  // Cron Jobs
  CRONJOBS: BASE_URL + '/api/admin-cron',
  CRONJOB_DELETE: (jobId) => BASE_URL + `/api/admin-cron/${jobId}`,
  CRONJOB_REPORTS: {
    USER: BASE_URL + '/api/admin-cron/reports/user',
    REVENUE: BASE_URL + '/api/admin-cron/reports/revenue',
    SUMMARY: BASE_URL + '/api/admin-cron/reports/summary',
  },

  UPLOAD_PROFILE_IMAGE: BASE_URL + "/api/admin-panel/me/upload",
  FORGOTPASSWORD: BASE_URL + '/api/admin-auth/forgot-password',
  GET_MEDIA: BASE_URL + '/api/admin-media',
  SYSTEM_STATS: BASE_URL + '/api/admin-server/stats',
  SYSTEM_SETTINGS: BASE_URL + '/api/admin-panel/settings',
  SYSTEM_SETTINGS_BULK: BASE_URL + '/api/admin-panel/settings/bulk',
  ADMIN_MANAGE_SUBSCRIPTION: BASE_URL + '/api/admin-panel/manage',
  GET_PERSONALITY_LIST: BASE_URL + '/api/admin-panel/personality-types',
  GET_PERSONALITY: (id) => BASE_URL + `/api/admin-panel/personality-types/${id}`,
  UPDATE_PERSONALITY: (id) => BASE_URL + `/api/admin-panel/personality-types/${id}`,
  DELETE_PERSONALITY: (id) => BASE_URL + `/api/admin-panel/personality-types/${id}`,
  
  DELETE_PERSONALITY_BULK: BASE_URL + '/api/admin-panel/personality-types',
  GET_SONG_LIST: BASE_URL + `/api/admin-panel/songs`,
  CREATE_SONG: BASE_URL + `/api/admin-panel/songs`,
  UPLOAD_MEDIA_LIST: BASE_URL + '/api/admin-panel/media-gallery/upload',
  GET_SONG: (id) => BASE_URL + `/api/admin-panel/songs/${id}`,
  UPDATE_SONG: (id) => BASE_URL + `/api/admin-panel/songs/${id}`,
  DELETE_SONGS: (id) => BASE_URL + `/api/admin-panel/songs/${id}`,
  GET_MEDIA_LIST: BASE_URL + '/api/admin-panel/media-gallery',
    GET_MEDIA_LIST_ITEM: (id) => BASE_URL + `/api/admin-panel/media-gallery/${id}`,
  DELETE_SINGLE_MEDIA: (id) => BASE_URL + `/api/admin-panel/media-gallery/${id}`,

  // Admin Events
  GET_EVENTS: BASE_URL + '/api/admin-events/',
  GET_SINGLE_EVENT: (id) => BASE_URL + `/api/admin-events/${id}`,
  CREATE_EVENT: BASE_URL + '/api/admin-events/',
  UPDATE_EVENT: (id) => BASE_URL + `/api/admin-events/${id}`,
  DELETE_EVENT: (id) => BASE_URL + `/api/admin-events/${id}`,
  APPROVE_EVENT: (id) => BASE_URL + `/api/admin-events/${id}/approve`,
  GET_EXTERNAL_EVENTS: BASE_URL + '/api/admin-events/external',
  GET_EVENT_ATTENDEES: (id) => BASE_URL + `/api/admin-events/${id}/attendees`,
  WS_URL,
};

/**
 * Converts any localhost-based media URL to your server URL.
 */
export function ImgURL(url, size = null) {
  if (!url) return url;

  let finalUrl = url;

  if (url.startsWith('http')) {
    // If it's already a full URL, but pointing to localhost/127.0.0.1, replace with current BASE_URL
    finalUrl = url
      .replace(/^http:\/\/localhost(?::\d+)?/, BASE_URL)
      .replace(/^http:\/\/127\.0\.0\.1(?::\d+)?/, BASE_URL);
  } else if (url.startsWith('/')) {
    // If it's a relative path with leading slash, just prepend BASE_URL
    finalUrl = `${BASE_URL}${url}`;
  } else {
    // If it's just a filename, we need to guess.
    const isUuid = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/i.test(url);
    const folder = isUuid ? 'user_media_uploads' : 'uploads';
    finalUrl = `${BASE_URL}/${folder}/${url}`;
  }

  if (size === 150 || size === 720) {
    const urlObj = finalUrl.split('?');
    const path = urlObj[0];
    const params = urlObj[1] ? `?${urlObj[1]}` : '';

    const ext = path.split('.').pop();
    const withoutExt = path.substring(0, path.lastIndexOf('.'));
    
    if (!withoutExt.includes('_thumb_')) {
      return `${withoutExt}_thumb_${size}.${ext}${params}`;
    }
  }

  return finalUrl;
}
